import { EntityType } from "Model/EntityType";
import { IWithAddressAndName } from "Model/Storage/IWithAddressAndName";
import { IItem } from "../Model/Storage/IItem";
import { isCompany, isContact, isProject } from "./IsType";
import { ObjectWalkerCallback, walk } from "./ObjectWalker";
import { isNotNullOrWhiteSpace, isNullOrWhiteSpace } from "./String";

export function updateProjectItem<T extends IItem>(item: T, id: string, callback: ObjectWalkerCallback<IItem>): T {
  return walk<T>(item, `companies.contacts`, (i) => i[`@id`] === id, callback);
}

export function updateAllItems<T extends IItem>(item: T, callback: ObjectWalkerCallback<IItem>): T {
  return walk<T>(item, `companies.contacts`, () => true, callback);
}

export function getItemById(item: IItem, id: string): IItem {
  if (isNullOrWhiteSpace(id)) {
    return null;
  }

  let foundItem: IItem = null;
  walk<IItem>(
    item,
    `companies.contacts`,
    (i) => i[`@id`] === id,
    (i) => {
      foundItem = i;
      foundItem.dataSource = item.dataSource;
      return undefined;
    }
  );

  return foundItem;
}

export function getName(item: IWithAddressAndName): string {
  if (item == null) {
    return `Unknown`;
  }

  if (isNotNullOrWhiteSpace(item.name)) {
    return item.name;
  }

  if (isNotNullOrWhiteSpace(item.fullName)) {
    return item.fullName;
  }

  if (isNotNullOrWhiteSpace(item.firstName) && isNotNullOrWhiteSpace(item.lastName)) {
    return `${item.firstName} ${item.lastName}`;
  }

  return `Unknown`;
}

export function getItemType(item: IItem): EntityType {
  if (isProject(item)) {
    return EntityType.Project;
  }

  if (isCompany(item)) {
    return EntityType.Company;
  }

  if (isContact(item)) {
    return EntityType.Contact;
  }

  return EntityType.None;
}
